import React from 'react';

const ColumnsIcon = (props) => (
  <svg
    width="13"
    height="15"
    viewBox="0 0 13 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.375 0H1.25C0.918479 0 0.600537 0.131696 0.366116 0.366116C0.131696 0.600537 0 0.918479 0 1.25V13.75C0 14.0815 0.131696 14.3995 0.366116 14.6339C0.600537 14.8683 0.918479 15 1.25 15H4.375C4.70652 15 5.02446 14.8683 5.25888 14.6339C5.4933 14.3995 5.625 14.0815 5.625 13.75V1.25C5.625 0.918479 5.4933 0.600537 5.25888 0.366116C5.02446 0.131696 4.70652 0 4.375 0ZM4.375 13.75H1.25V1.25H4.375V13.75ZM11.25 0H8.125C7.79348 0 7.47554 0.131696 7.24112 0.366116C7.0067 0.600537 6.875 0.918479 6.875 1.25V13.75C6.875 14.0815 7.0067 14.3995 7.24112 14.6339C7.47554 14.8683 7.79348 15 8.125 15H11.25C11.5815 15 11.8995 14.8683 12.1339 14.6339C12.3683 14.3995 12.5 14.0815 12.5 13.75V1.25C12.5 0.918479 12.3683 0.600537 12.1339 0.366116C11.8995 0.131696 11.5815 0 11.25 0ZM11.25 13.75H8.125V1.25H11.25V13.75Z"
      fill="currentColor"
    />
  </svg>
);

export default ColumnsIcon;

